import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import useLanguageTranslate from "../../../hooks/useLanguageTranslate";
import {
  formatPremiumValue,
  formatPremiumWithCurrency,
} from "../../../utils/index";
import Button from "../../common/Button/Button";

const BottomStickyBtnLayout = ({
  children,
  btn_label,
  btn_onClick,
  btn_disabled,
  show_summary,
  show_summary_btn = false,
  summary_price,
  summary_btn_text,
  summary_btn_onClick,
  price,
  AdditionalComponent,
  hideContinueBtn = false,
  addonComponent,
  isLoading = false,
  onContinue,
  onShowSummary,
}) => {
  const { i18n } = useTranslation();
  const translate = useLanguageTranslate();

  // Resolve the stable portal target rendered by NewAmanPolicy.
  // Falls back to inline rendering when used outside that flow.
  const [portalTarget, setPortalTarget] = useState(null);
  useEffect(() => {
    if (typeof document === "undefined") return;
    setPortalTarget(document.getElementById("aman-footer-portal"));
  }, []);

  const formatFooterCurrency = (amount) => {
    const isRTL = i18n.resolvedLanguage === "ar";

    if (isRTL) {
      return `${formatPremiumValue(amount, "en-US", 3)} د.ب`;
    } else {
      return formatPremiumWithCurrency(amount, "BHD", "en-US");
    }
  };

  const handleContinue = (e) => {
    if (onContinue) {
      onContinue(e);
    } else if (btn_onClick) {
      btn_onClick(e);
    }
  };

  const handleShowSummary = () => {
    if (onShowSummary) {
      onShowSummary();
    } else if (summary_btn_onClick) {
      summary_btn_onClick();
    }
  };

  const footer = (
      <div className="footer items-center bg-white border-t border-[#E5E9EB] w-full py-2 flex justify-end fixed pr-10 bottom-0 z-[100] max767:w-full max767:px-4 max767:pt-3 max767:pb-[max(2.25rem,calc(env(safe-area-inset-bottom)+1rem))] max767:pr-4 max767:pl-4 max767:inset-x-0 ipad:items-center max767:flex max767:flex-col max767:items-stretch max767:justify-start rtl:pr-0 rtl:pl-10 max767:rtl:pl-4 max767:rtl:pr-4">
        {addonComponent && addonComponent}

        {show_summary && (
          <div className="flex items-center gap-4 mr-10 max767:w-full max767:mb-2 max767:justify-between max767:mr-0 rtl:ml-10 rtl:mr-0 max767:rtl:ml-0">
            <button
              onClick={handleShowSummary}
              className="text-[#00384D] text-center text-base not-italic font-semibold underline"
            >
              {translate("Show Summary", "ملخص العرض")}
            </button>
            <p className="text-black text-center text-xl not-italic font-semibold max767:text-right max767:rtl:text-left">
              {formatFooterCurrency(price)}
            </p>
          </div>
        )}

        {!hideContinueBtn && (
          <Button
            label={btn_label || translate("Continue", "استمرار")}
            className={`cursor-pointer ${
              btn_disabled
                ? "bg-[#B0BABF] text-white"
                : "text-[#1A2024] bg-[#55C6EF]"
            } px-[52px] py-3 rounded-[10px] max767:mt-0 max767:w-full max767:h-[48px] font-bold text-lg leading-6 tracking-[-0.18px] ${
              isLoading ? "opacity-70 cursor-not-allowed" : ""
            }`}
            onSubmit={handleContinue}
            disabled={btn_disabled || isLoading}
            isLoading={isLoading}
          />
        )}
      </div>
  );

  return (
    <>
      {children}
      {portalTarget ? createPortal(footer, portalTarget) : footer}
    </>
  );
};

export default BottomStickyBtnLayout;
